class ContainerValidation {
  isItemAvailable(container: Array<any>, payload: any): number | null {
    let index: number | null = container.findIndex(element => {
      return element.equipmentRef === payload.equipmentRef
    })

    if (!('equipments' in container[index])) {
      index = null
    }

    if (index !== null && Object.keys(container[index].equipments).length === 0) {
      index = null
    }

    return index
  }

  isItemsSuccess(item: Array<any> = []): boolean {
    let result = false
    item.forEach(element => {
      result = (element?.success ?? false) && (!element?.error ?? false)
    })
    return result
  }

  isDetailsSuccess(details: { success: boolean; error: boolean }): boolean {
    return details?.success === true && details?.error === false
  }

  validateContainer(container: Array<any> = []) {
    container.forEach(element => {
      if ('equipments' in element) {
        const details = this.isDetailsSuccess(element.equipments?.details)
        const points = this.isItemsSuccess(element.equipments?.points)
        const channels = this.isItemsSuccess(element.equipments?.channels)
        element.success = details && points && channels
        element.error = !(details && points && channels)
      } else {
        element.success = true
        element.error = false
      }
    })
  }

  isValid(container: Array<any>): boolean {
    let result = true
    this.validateContainer(container)
    container.forEach(element => {
      if (element.error === true) {
        result = false
      }
    })
    return result
  }
}

export default ContainerValidation
